export const initialState = {
  loading: true,
  silos: null,
  siloSeleccionado: null,
  silosValidosVolcadora: [],
  filtrado: false,
  cereal: null,
  variedad: null
}

export const estadoSilosReducer = (state = initialState, { type, ...other }) => {
  switch (type) {
    case 'UPDATE_ESTADO_SILOS':
      return {
        ...state,
        ...other
      }
    case 'UPDATE_SILO_SELECCIONADO':
      return {
        ...state,
        siloSeleccionado: other.silo
      }
    case 'UPDATE_ESTADO_FILTRADO':
      return {
        ...state,
        filtrado: true,
        cereal: other.cereal,
        variedad: other.variedad
      }
    case 'RESET_ESTADO_FILTRADO':
      return {
        ...state,
        filtrado: false,
        cereal: null,
        variedad: null
      }
    default:
      return state
  }
}
